"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOUCH_ACTIVATION = exports.MOUSE_ACTIVATION = void 0;
var MOUSE_ACTIVATION = {
  CLICK: "click",
  DOUBLE_CLICK: "doubleClick",
  HOVER: "hover",
  MOUSE_DOWN: "mouseDown"
};
exports.MOUSE_ACTIVATION = MOUSE_ACTIVATION;
var TOUCH_ACTIVATION = {
  DOUBLE_TAP: "doubleTap",
  LONG_TOUCH: "longTouch",
  TAP: "tap",
  TOUCH: "touch"
};
exports.TOUCH_ACTIVATION = TOUCH_ACTIVATION;